export default() => {

	const els =  document.querySelectorAll('.text-page__richtext p');


	els.forEach(function(el) {
		const pattern = new RegExp('^(\\d+)\\.(\\d+)');
		const isPassed = pattern.test(el.innerText);

		//get pattern text from text
		

		//remove pattern text from text
		


		if (isPassed) {
			el.classList.add('p-li');
			const patternText = el.innerText.match(pattern);
			const text = el.innerText.replace(pattern, '');
			el.innerText = text;

			const span = document.createElement('span');
			span.innerText = patternText[0];
			span.classList.add('p-li__number');

			el.prepend(span);
		}
		
	});
}